import { __decorate, __metadata, __param } from "tslib";
import { Globals } from '../../Misc';
import NeoTypes from '../../AppServices/NeoTypes';
import { ModalUtils } from '../Modal/ModalUtils';
import { injectable, inject } from 'inversify';
var NotificationHelper = /** @class */ (function () {
    /**
     * Creates a new notification helper which can be bound to a ToastContainer / other alert ui component.
     * @param store Optional store which contains the notification message objects.
     */
    function NotificationHelper(store) {
        this._store = store;
    }
    Object.defineProperty(NotificationHelper.prototype, "store", {
        get: function () {
            if (!this._store) {
                this._store = Globals.appService.get(NeoTypes.UI.NotificationStore);
            }
            return this._store;
        },
        enumerable: false,
        configurable: true
    });
    /** Adds a notification using the primary style. See `add` for more details */
    NotificationHelper.prototype.addPrimary = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "primary", autoHideTimeSeconds);
    };
    /** Adds a notification using the secondary style. See `add` for more details */
    NotificationHelper.prototype.addSecondary = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "secondary", autoHideTimeSeconds);
    };
    /** Adds a notification using the success style. See `add` for more details */
    NotificationHelper.prototype.addSuccess = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "success", autoHideTimeSeconds);
    };
    /** Adds a notification using the warning style. See `add` for more details */
    NotificationHelper.prototype.addWarning = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "warning", autoHideTimeSeconds);
    };
    /** Adds a notification using the danger style. See `add` for more details */
    NotificationHelper.prototype.addDanger = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "danger", autoHideTimeSeconds);
    };
    /** Adds a notification using the info style. See `add` for more details */
    NotificationHelper.prototype.addInfo = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "info", autoHideTimeSeconds);
    };
    /** Adds a notification using the light style. See `add` for more details */
    NotificationHelper.prototype.addLight = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "light", autoHideTimeSeconds);
    };
    /** Adds a notification using the dark style. See `add` for more details */
    NotificationHelper.prototype.addDark = function (heading, body, autoHideTimeSeconds) {
        return this.add(heading, body, "dark", autoHideTimeSeconds);
    };
    /**
     * Adds a notification to the notification list
     * @param heading Text to show in the header
     * @param body Text or component to show in the body
     * @param variant Bootstrap variant
     * @param autoHideTimeSeconds Number of seconds to wait before auto hiding the notification. The notification wont automatically close if this is unspecified.
     */
    NotificationHelper.prototype.add = function (heading, body, variant, autoHideTimeSeconds) {
        return this.store.add(heading, body, variant, autoHideTimeSeconds);
    };
    /**
     * Adds a notification to the notification list if the specified key is not already in the list.
     * @param key Unique key for this type of notification
     * @param heading Text to show in the header
     * @param body Text or component to show in the body
     * @param variant Bootstrap variant
     * @param autoHideTimeSeconds Number of seconds to wait before auto hiding the notification. The notification wont automatically close if this is unspecified.
     */
    NotificationHelper.prototype.addOrUpdate = function (key, heading, body, variant, autoHideTimeSeconds) {
        return this.store.addOrUpdate(key, heading, body, variant, autoHideTimeSeconds);
    };
    /**
     * Hides a notification that was added with the specified key.
     * @param key Unique key for this type of notification
     */
    NotificationHelper.prototype.remove = function (key) {
        this.store.remove(key);
    };
    /**
     * Hide and remove all notifications being displayed.
     * @param animate True to apply hide animation.
     */
    NotificationHelper.prototype.hideAll = function (animate) {
        if (animate) {
            this.store.notifications.forEach(function (c) { return c.hide(); });
        }
        else {
            this.store.notifications = [];
        }
    };
    /**
    * Shows a message or component in a modal dialog. The user can click ok, or click the close button to dismiss the modal.
    * The returned promise will resolve in either case.
    * @param title The title in the header
    * @param message The message or component to display
    */
    NotificationHelper.prototype.showMessage = function (title, message) {
        return ModalUtils.showMessage(title, message);
    };
    NotificationHelper = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.UI.NotificationStore.symbol)),
        __metadata("design:paramtypes", [Object])
    ], NotificationHelper);
    return NotificationHelper;
}());
export { NotificationHelper };
